import styled from 'styled-components';

export const RenderImageAd = styled.div`
  max-width: 200px;
  height: 200px;
  background-image: url(${props => props.url});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
`;
